const baseMdcBlockGroup = require('./_BaseMdcBlockGroup');
class Documentation extends baseMdcBlockGroup {
    addCodeGeneratorCustom(code) {
        return JSON.stringify(code);
    }
}

module.exports= Documentation;
